// https://github.com/jquense/yup
// Dead simple Object schema validation

import * as yup from "yup";

// Media profile header edit schema — the media sibling of pr_profile_schema. The media header edits the
// same identity fields as the PR header (first_name, last_name, headline_custom, bio), so the validation
// rules mirror the PR schema's: both names are required, the headline is capped at the column's 200-char
// limit, and bio is free-form (no rule).
const mediaProfileYupSchema = yup.object().shape({
  first_name: yup.string().required("First name is required."),
  last_name: yup.string().required("Last name is required."),
  // Trimmed before the length check because the value is trimmed before it is sent, and the server
  // strips it too — validating the untrimmed input would reject padding the user never submits.
  headline_custom: yup
    .string()
    .transform((value) => (typeof value === "string" ? value.trim() : value))
    .max(200, "Headline must be 200 characters or fewer."),
  // The picked place's address can rarely exceed the 100-char column; validate for a clear message
  // instead of a server 422. Nullable so Remove's explicit null passes.
  location_string: yup.string().nullable().max(100, "Location must be 100 characters or fewer."),
});

export default mediaProfileYupSchema;
